export const UNIT_CODE_LENGTH = 10;

export const UNIT_SCAN_MODES = {
  PICK: 'PICK',
  RETURN_INWARD: 'RETURN_INWARD',
};

export const UNIT_SCAN_STEPS = {
  CODE: 'CODE',
  BLOCKED: 'BLOCKED',
  FORM: 'FORM',
  DONE: 'DONE',
};

export const UNIT_BLOCK_REASON_LABELS = {
  UNIT_NOT_FOUND: 'No unit found for this code.',
  QR_NOT_ACTIVE: 'This unit is not activated yet.',
  UNIT_NOT_ACTIVATED: 'This unit is not activated yet.',
  ORDER_ITEM_NOT_FOUND: 'This order item could not be found.',
  RETURN_ORDER_ITEM_NOT_FOUND: 'This return item could not be found.',
  TOY_MISMATCH: 'This unit belongs to a different toy.',
  LIBRARY_MISMATCH: 'This unit belongs to a different library.',
  ORDER_ITEM_NOT_PICKABLE: 'This order item cannot be picked right now.',
  RETURN_ORDER_ITEM_NOT_PICKABLE: 'This return item cannot be inwarded yet.',
  UNIT_NOT_LINKED_TO_ORDER_ITEM: 'This unit is not linked to this order item.',
  UNIT_ASSIGNED_TO_ANOTHER_ORDER_ITEM:
    'This unit is already assigned to another order item.',
  ORDER_ITEM_ALREADY_ASSIGNED: 'This order item already has its units.',
  RETURN_ORDER_ITEM_ALREADY_ASSIGNED: 'This return item is already inwarded.',
  UNIT_NOT_DISPATCHABLE: 'This unit cannot be dispatched.',
  UNIT_NOT_WITH_CUSTOMER: 'This unit is not with the customer.',
  CHECKLIST_FAILED: 'The checklist did not pass for this unit.',
  UNIT_NOT_READY_FOR_INWARD: 'This unit is not ready to be inwarded.',
  UNIT_DAMAGED:
    'This unit is marked damaged and is under review. It cannot be used until the damage request is resolved.',
  UNIT_DEACTIVATED: 'This unit is deactivated.',
  OUT_OF_STOCK: 'This toy is out of stock in this library.',
};

export const getBlockReasonMessage = (checkData) =>
  checkData?.message ||
  UNIT_BLOCK_REASON_LABELS?.[checkData?.blockReason] ||
  'This unit cannot be used here.';

export const IGNORED_BLOCK_REASONS = ['UNIT_NOT_ACTIVATED', 'QR_NOT_ACTIVE'];

export const isIgnoredBlockReason = (checkData) =>
  IGNORED_BLOCK_REASONS?.includes(checkData?.blockReason);

export const isHardBlock = (checkData) =>
  Boolean(checkData?.blockReason) && !isIgnoredBlockReason(checkData);
